import { css } from '@inter-ikea-kompis/web-component';
export default class DoNotDiyStyle {
    /**
     * Returns styles.
     *
     * @returns Styles.
     */
    static getStyle() {
        return css `
			:host {
				display: flex;
			}

			img {
				height: ${64 / 16}rem;
			}
		`;
    }
}
//# sourceMappingURL=DoNotDiyStyle.js.map